import { doc, setDoc, collection } from "firebase/firestore";
import { db } from "../firebase";
import Cookies from "js-cookie";
import { v4 as uuidv4 } from "uuid"; // Optional: for generating a unique ID

export const Saveskills_categories = async (data) => {
   
  const docRef = doc(db, "skills_categories", data.skillsId);

  const savequery = {
    ...data, 
    guid: Cookies.get("guid"),
    update_date_time: new Date(),
    date_time: new Date(),
    device: navigator.userAgent,
    ip: Cookies.get("ipaddres"),
    status: true,
  };

  try {
    await setDoc(docRef, savequery);
    return { success: true };
  } catch (err) {
    console.error("Error saving post:", err);
    return { success: false, error: err.message };
  }
};
